import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=48a6f826"
import script from "./TipTapEditor.vue?vue&type=script&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&lang=js"
import style0 from "./TipTapEditor.vue?vue&type=style&index=0&id=48a6f826&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports